import React, { Component } from 'react';
import moment from 'moment';
import EventDetails from './EventDetails';
import PatientInformation from './PatientInformation';

import { connect } from 'react-redux';
import { alertActions } from '../../../_actions/alert.actions';
import { eventService } from '../../../_services/event.service';

class CreateEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      group: {},
      chartId: "",
      otherId: "",
      provider: {},
      lastName: "",
      firstName: "",
      date: "",
      time: "",
      eventType: {},
      eventItems: [],
      availableOn: "",
      dateOfBirth: "",
      currentStep: 'PATIENT_INFORMATION',
      cellPhoneNumber: "",
      isSaving: false
    }
    this.handleSetState = this.handleSetState.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBackStep = this.handleBackStep.bind(this);
    this.handleSortItems = this.handleSortItems.bind(this);
    this.handleSaveEvent = this.handleSaveEvent.bind(this);
    this.handleAddEventItem = this.handleAddEventItem.bind(this);
    this.handleRescheduleEventItem = this.handleRescheduleEventItem.bind(this)
  }

  handleSetState(name, value) {
    this.setState({ [name]: value })
  }

  handleNextStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'PATIENT_INFORMATION':
        nextStep = 'EVENT_DETAILS';
        break;
      default:
        return false;
    }
    this.setState({ currentStep: nextStep });
  }

  handleBackStep() {
    let nextStep;

    switch (this.state.currentStep) {
      case 'EVENT_DETAILS':
        nextStep = 'PATIENT_INFORMATION';
        break;
      default:
        return false;
    }
    this.setState({ currentStep: nextStep });
  }

  handleSortItems(eventItems) {
    if (eventItems.length > 0) {
      eventItems.sort((a, b) => { return moment(a.date) - moment(b.date) })
    }
    return eventItems
  }

  handleAddEventItem(item) {
    const eventItems = [
      { id: this.state.eventItems.length + 1, ...item },
      ...this.state.eventItems,
    ];
    this.setState({ eventItems: this.handleSortItems(eventItems) });
  }

  handleRescheduleEventItem(eventItem, updatedEvent) {
    const eventItems = this.state.eventItems;
    const updatedItems = eventItems.map(item => {
      if (item.id === updatedEvent.id) {
        if (JSON.stringify(item) !== JSON.stringify(updatedEvent)) {
          alert(`${item.type} Rescheduled!`);
          return updatedEvent;
        }
      }
      return item;
    })
    this.setState({ eventItems: this.handleSortItems(updatedItems) });
  }

  handleSaveEvent() {
    this.setState({ isSaving: true });

    const data = {
      patient: {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        dateOfBirth: moment(this.state.dateOfBirth).format('YYYY-MM-DD'),
        phoneNumber: this.state.cellPhoneNumber,
        emailAddress: this.state.email,
        chartId: this.state.chartId,
        otherId: this.state.otherId
      },
      event: {
        typeId: this.state.eventType.value,
        date: moment(this.state.date).format('YYYY-MM-DD'),
        time: this.state.time ? moment(this.state.time).format('HH:mm') : null,
        doctorId: this.state.provider.value,
        groupId: this.state.group.value,
        items: this.state.eventItems.map(item => {
          const data = {
            doctorId: item.doctor.id,
            groupId: item.providerGroup.id,
            formId: item.type === 'Form' ? item.form.id : item.preVisitQuestions.id,
            type: item.type === 'Form' ? 'FORM' : 'TELEHEALTH'
          }

          if (data.type === 'FORM') {
            data.completeByDate = moment(item.date).format('YYYY-MM-DD HH:mm');
            data.formAvailableOnDate = item.availableOn !== "Immediately" ? moment(item.availableOn).format('YYYY-MM-DD HH:mm') : null
          } else {
            data.appointmentDate = moment(item.date).format('YYYY-MM-DD HH:mm');
            data.telehealthAvailableOnDate = item.availableOn !== "Immediately" ? moment(item.availableOn).format('YYYY-MM-DD HH:mm') : null
            data.telehealthType = item.telehealthType;
          }

          return data;
        })
      }
    }

    eventService.scheduleEvent(data)
      .then(() => {
        this.setState({ isSaving: false });
        this.props.history.push('/events');
        this.props.dispatch(alertActions.success('The event has been scheduled!'));
      })
      .catch((error) => {
        this.setState({ isSaving: false });

        if (error.response && error.response.status === 422) {
          for (const message in error.response.data) {
            this.props.dispatch(alertActions.error(error.response.data[message]));
          }
        } else {
          this.props.dispatch(alertActions.error('Could not schedule the event at this time. Please try again.'));
        }
      });
  }

  render() {
    const { currentStep } = this.state;

    return (
      <div className="row">
        <div className="col-lg-12">
          <PatientInformation
            nextStep={this.handleNextStep}
            setValue={this.handleSetState}
            currentStep={currentStep}
            email={this.state.email}
            chartId={this.state.chartId}
            otherId={this.state.otherId}
            lastName={this.state.lastName}
            firstName={this.state.firstName}
            dateOfBirth={this.state.dateOfBirth}
            cellPhoneNumber={this.state.cellPhoneNumber}
          />
        </div>

        <div className="col-lg-12">
          <EventDetails
            nextStep={this.handleNextStep}
            backStep={this.handleBackStep}
            setValue={this.handleSetState}
            saveEvent={this.handleSaveEvent}
            addEventItem={this.handleAddEventItem}
            rescheduleEventItem={this.handleRescheduleEventItem}
            currentStep={currentStep}
            group={this.state.group}
            provider={this.state.provider}
            isSaving={this.state.isSaving}
            date={this.state.date}
            time={this.state.time}
            eventType={this.state.eventType}
            eventItems={this.state.eventItems}
            availableOn={this.state.availableOn}
          />
        </div>
      </div>
    )
  }
}

export default connect()(CreateEvent);